import * as React from "react"
import Page from "./about"

export default function IndexPage() { 
	return ( <Page />)
}

